import React from 'react';
import { Link, Typography } from '@material-ui/core';
import { ThemeContext } from '../../../contexts/ThemeContext';
import { Footer as AppFooter } from './styles';

export default class Footer extends React.Component {
  render() {
    return (
      <AppFooter>
        <ThemeContext.Consumer>
          {theme => (
            <div className="footer">
              <div className="all-footer">
                <div className="left-footer">
                  <b className="left-item-footer">
                    {theme.footerMessage}
                  </b>
                </div>
                <div className="links-educat">
                  <div className="contato">
                    <a className="email-footer">
                      {theme.footerEmail}
                    </a>
                    <a className="tel-footer">
                      {theme.footerNumber}
                    </a>
                    {theme.footerNumber && theme.footerEmail && (
                      <div className="hr" />
                    )}

                    {theme.linkFabBody && (
                      <div className="report-int">
                        <Typography>
                          <Link
                            href={theme.linkFabBody}
                            target="_blank"
                            disabled={!theme.linkFabBody}
                          >
                            Reportar Intercorrência
                          </Link>
                        </Typography>
                      </div>
                    )}
                  </div>
                  <a
                    href="https://educat.com.br/"
                    className="img-footer"
                    target="_blank"
                  >
                    <img className="logo" alt="logo_educat" src={theme.footerImageOrText} />
                  </a>
                </div>
              </div>
            </div>
          )}
        </ThemeContext.Consumer>
      </AppFooter>
    );
  }
}
